import { Lead } from '../../../domain/entities/Lead';
import { supabase } from '../../../lib/supabase';
import { LeadQueries } from './LeadQueries';

export class LeadStatsQueries {
    private static readonly HIGH_VALUE_THRESHOLD = 10000;
    private static readonly STALE_DAYS = 30;
    private static readonly TABLE_NAME = 'opportunities';

    static async findHighValue(organizationId?: string): Promise<Lead[]> {
        const query = LeadQueries.buildQuery(organizationId)
            .eq('status', 'open') // Apenas abertas
            .gte('value', this.HIGH_VALUE_THRESHOLD);
        return LeadQueries.executeSafeQuery(query, 'findHighValue');
    }

    static async findStale(organizationId?: string): Promise<Lead[]> {
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - this.STALE_DAYS);

        const query = LeadQueries.buildQuery(organizationId)
            .eq('status', 'open') // Apenas abertas
            .lt('created_at', thirtyDaysAgo.toISOString());
        return LeadQueries.executeSafeQuery(query, 'findStale');
    }

    /**
     * Busca negociações ganhas
     */
    static async findWon(organizationId?: string): Promise<Lead[]> {
        return LeadQueries.executeQuery(
            LeadQueries.buildQuery(organizationId).eq('status', 'won'),
            'findWon',
            'Erro ao buscar negociações ganhas'
        );
    }

    /**
     * Busca negociações perdidas
     */
    static async findLost(organizationId?: string): Promise<Lead[]> {
        return LeadQueries.executeQuery(
            LeadQueries.buildQuery(organizationId).eq('status', 'lost'),
            'findLost',
            'Erro ao buscar negociações perdidas'
        );
    }

    static async count(organizationId?: string): Promise<number> {
        return LeadQueries.executeCountQuery(
            LeadQueries.buildCountQuery(organizationId),
            'count'
        );
    }

    static async countByStage(stageId: string): Promise<number> {
        if (!stageId || stageId.trim().length === 0) return 0;

        const query = supabase
            .from(this.TABLE_NAME)
            .select('*', { count: 'exact', head: true })
            .eq('stage', stageId);

        return LeadQueries.executeCountQuery(query, 'countByStage');
    }
}
